import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const DealpipelinesCreate = props => (
  <Create {...props} resource="dealpipelines">
    <Form />
  </Create>
);

DealpipelinesCreate.propTypes = {};

export default DealpipelinesCreate;
